import { z } from 'zod'

export const selectOptionBackSchema = z.object({
  label: z.string(),
  id: z.string()
})

export const numericSelectOptionBackSchema = z.object({
  label: z.string(),
  id: z.number()
})

export type SelectOption<T = object, K = string> = {
  label: string
  id: K
} & T
